import React, { Component } from 'react';
import {Modal} from 'react-bootstrap';
import {connect} from 'react-redux';
import * as actionCreator from "../../action/quote_order/leadcustomer.action.js"
import CommonPromptBox from "./CommonPromptBox";
import { copyToClickboard } from '../../redux/reducers/utils.js';
import { const_var } from '../../redux/reducers/reducer.js';
class SuccessOq extends React.Component {
constructor(props) {
  super(props);
  this.state = {
    url: "https://www.google.com/"
  };
}
showModal=()=>{
  this.setState({ showModal: true });
}

closeModal = () => {
  this.setState({showModal: false,closeModalCancel:true});
}

render() {
    this.state = {
      showModal: (this.state==null || this.state.closeModalCancel==undefined)?this.props.thankYouForSaveLater:false
    };
  let DisplayName="";
  let disName = "";
  let newODQT = ""
  let editODQ = "";
  let lDSQT = "";
  if(this.props.is_module_name=="quote")
  {
      DisplayName = "Quote";
      disName = "vqt";
      newODQT = "nqts";
      editODQ = "eqt";
      lDSQT = "vld";
  } else if(this.props.is_module_name=="inventory") {
    DisplayName = "Inventory";
  }else
  {
    DisplayName = "Order";
    disName = "vord";
    newODQT = "vord";
    editODQ = "eord";
    lDSQT = "vcst";
  }
  let msg = "";
  if(this.props.checkImageCount.length>0)
  {
      msg = "We are saving your building configuration.Please don’t refresh the page or go back; It won’t take long. ";
  }else{
      msg = "Hey! We’ll take pictures of this building to attach to the quote/order. It’s nice to be on the same page. Please don’t refresh the page or go back; It won’t take long. ";
  }
    return (
      <div>
        <Modal
          centered
          show={this.props.isShowSuccessOq}
          backdrop="static"
          keyboard={false}
          onHide={(e) => this.props.handleCommonModal("close")}
          dialogClassName={this.props.returnRespone.status == false ? "react-modal new-alert-modal new-alert-modal-width-over" : "react-modal success-oq-modal thanks-modal hide-modal-footer-img"}
        >
          {this.props.returnRespone.status == false ? (
            <button
              className={const_var.crmSetting.main_domain_url ? "close close-icon" : "close"}
              onClick={(e) => this.props.handleCommonModal("close")}
            >
              <span className={const_var.crmSetting.main_domain_url ? "icon-close close-icon-model" : "icon-close"}></span>
            </button>
          ) : (
            <a
              className={const_var.crmSetting.main_domain_url ? "close close-domain-url" : "close"}
              href={
                this.props.targetRedirectUrl.loggeedincrmflag == true
                  ? this.props.targetRedirectUrl.loggeedincrmflagURL
                  : this.props.targetRedirectUrl.web_url +
                    "/" +
                    this.props.targetRedirectUrl[this.props.is_module_name]?.view +
                    this.props.returnRespone.id
              }
            >
              <span className={const_var.crmSetting.main_domain_url ? "icon-close close-icon-model" : "icon-close"}></span>
            </a>
          )}
          <Modal.Body>
            <div
              className={
                this.props.i_g_A_y == true
                  ? " fullpage-loader spinner-loader please-wait"
                  : "fullpage-loader spinner-loader spinner-active please-wait"
              }
            >
              <div className="spinner-loader">
                <div className="spinner"></div>
              </div>
              <div className="spinner-content">
                <h6 className="big-font">PLEASE WAIT</h6>
                <p className="mb-3 mt-3 roboto-medium msg-text">{msg}</p>
                <p className="mb-0 roboto-bold text-uppercase text-dark">
                  Thank You for your patience!!
                </p>
              </div>
            </div>
            <>
              {this.props.returnRespone.status == false ? (
                <div className="serve-error">
                  <h5 className="modal-title">!Oops your <span className='type-check'>{DisplayName}</span> could not be processed due to:</h5>
                  {/* <p>Your {DisplayName} could not be processed due to:</p> */}
                  <ul className='error-arr'>
                    {this.props.returnRespone.errors.length > 0 ? (
                      this.props.returnRespone.errors.map((val, index) => {
                        return (
                          <li>
                            <p>
                              <span className="icon-info mr-1"></span>
                              {val}
                            </p>
                          </li>
                        );
                      })
                    ) : (
                      <li>
                        <p>
                          <span className="icon-info mr-1"></span>
                          {this.props.returnRespone.message}
                        </p>
                      </li>
                    )}
                  </ul>{" "}
                </div>
              ) : (
                <>
                  {this.props.returnRespone.status === true ? (
                    <p className="top-model-message">
                      Your {DisplayName} is successfully saved.{" "}
                      <span class="icon-success-tick"></span>
                    </p>
                  ) : null}
                  <div className="view-order-container">
                    {
                      (this.props.returnRespone?.share_link !== "" && this.props.returnRespone?.share_link != null && this.props.returnRespone?.share_link != undefined)  
                       ?
                       <div className="col-md-12 m-0 p-0 copy-url-container">
                          <p className={ const_var.crmSetting.main_domain_url ? "mb-1 mt-30 text-left share-url spc-btw" : "mb-1 mt-30 text-left share-url"}>
                            <div>
                              Share This {DisplayName}{" "}
                              <span className="icon-point-down-hand"></span>
                            </div>
                            
                            <a target={this.props.redirectcrmflag == true ? "" : "_blank"}
                               href={this.props.returnRespone.pdf_url} className={ const_var.crmSetting.main_domain_url ? 'viewPdf' : 'viewPdf d-none'}><span className="icon-view"></span>&nbsp; View PDF</a>
                          </p>
                          <textarea
                            rows={2}
                            className="copy-text-area w-full"
                            value={this.props.returnRespone.share_link}
                            id="my-text-area"
                          ></textarea>
                          {
                            const_var.crmSetting.main_domain_url 
                            ?
                             <button className={`copy-to-clickboard copy-to-clickboard-new changebg ${this.props.copyKlinkText == "Copied" ? '' : ' cursor-pointer' }`} onClick={(e) => {
                                  copyToClickboard();
                                  this.props.commonsActionforLeadCustomer(e.target.value,"change_klink_text")
                                }
                              }><i className='icon-copy-icon'></i></button>
                            :
                              <button className={`copy-to-clickboard ${this.props.copyKlinkText == "Copied" ? '' : ' cursor-pointer' }`} onClick={(e) => {
                                  copyToClickboard();
                                  this.props.commonsActionforLeadCustomer(e.target.value,"change_klink_text")
                                }
                              }>{this.props.copyKlinkText} {this.props.copyKlinkText == "Copied" && <i className='icon-check'></i> }</button>
                          }
                        </div>
                        :
                        <div className='copy-url-container m-6'></div>
                    }
      
                    <div className={const_var.crmSetting.main_domain_url ? "d-none" : "successoq-cta"}>
                      <>
                        {this.props.checkCustomerEdit == false ||
                        this.props.checkCustomerEdit == undefined ? (
                          <>
                            <a
                              target={
                                this.props.redirectcrmflag == true ? "" : "_blank"
                              }
                              href={
                                this.props.targetRedirectUrl.web_url + "/" +
                                this.props.targetRedirectUrl[
                                  this.props.is_module_name
                                ]?.view +
                                this.props.returnRespone.id
                              }
                            >
                              <span className="text">View {DisplayName}</span>
                              <span className="icon icon-arrow-double-small"></span>
                            </a>
                            {this.props.is_module_name == "quote" ? (
                              <a
                                target={
                                  this.props.redirectcrmflag == true ? "" : "_blank"
                                }
                                href={this.props.returnRespone.pdf_url}
                              >
                                <span className="text">View PDF</span>
                                <span className="icon icon-arrow-double-small"></span>
                              </a>
                            ) : null}
                            <a
                              target={
                                this.props.redirectcrmflag == true ? "" : "_blank"
                              }
                              href={
                                this.props.targetRedirectUrl.web_url + "/" +
                                this.props.targetRedirectUrl[
                                  this.props.is_module_name
                                ]?.create
                              }
                            >
                              <span className="text">New {DisplayName}</span>
                              <span className="icon icon-arrow-double-small"></span>
                            </a>
                            <a
                              target={
                                this.props.redirectcrmflag == true ? "" : "_blank"
                              }
                              className={
                                this.props.is_module_name == "order" ? "d-none" : ""
                              }
                              href={
                                this.props.targetRedirectUrl.web_url + "/" +
                                this.props.targetRedirectUrl[
                                  this.props.is_module_name
                                ]?.duplicate +
                                this.props.returnRespone.id
                              }
                            >
                              <span className="text">Duplicate {DisplayName}</span>
                              <span className="icon icon-arrow-double-small"></span>
                            </a>
                            <a
                              target={
                                this.props.redirectcrmflag == true ? "" : "_blank"
                              }
                              href={
                                this.props.targetRedirectUrl.web_url + "/" +
                                this.props.targetRedirectUrl[
                                  this.props.is_module_name
                                ]?.edit +
                                this.props.returnRespone.id
                              }
                            >
                              <span className="text">Edit {DisplayName}</span>
                              <span className="icon icon-arrow-double-small"></span>
                            </a>
                            <a
                              target={
                                this.props.redirectcrmflag == true ? "" : "_blank"
                              }
                              href={this.props.returnRespone.sub_module_url}
                            >
                              <span className="text text-capitalize">
                                View{" "}
                                {this.props.is_module_name == "quote"
                                  ? this.props.targetRedirectUrl.sub_module + "s"
                                  : "Customer"}
                              </span>
                              <span className="icon icon-arrow-double-small"></span>
                            </a>
                          </>
                        ) : (
                          <>
                            <a
                              target={
                                this.props.redirectcrmflag == true ? "" : "_blank"
                              }
                              href=""
                            >
                              <span className="text">View {DisplayName}</span>
                            </a>
                            {this.props.is_module_name == "quote" ? (
                              <a
                                target={
                                  this.props.redirectcrmflag == true ? "" : "_blank"
                                }
                                href={this.props.returnRespone.pdf_url}
                              >
                                <span className="text">View PDF</span>
                                <span className="icon icon-arrow-double-small"></span>
                              </a>
                            ) : null}
                          </>
                        )}
                      </>
                    </div>
                  </div>
                  <div className="add-new-lead d-none">
                    <a
                      target={this.props.redirectcrmflag == true ? "" : "_blank"}
                      href={
                        this.props.targetRedirectUrl.web_url + "/" +
                        this.props.targetRedirectUrl[this.props.is_module_name]?.create
                      }
                    >
                      <span className="add-new-lead-text">+ New {DisplayName}</span>
                    </a>
                  </div>
                </>
              )}
            </>
          </Modal.Body>
        </Modal>
        {this.props.alertUsedMSG != "" ? (
          <CommonPromptBox
            show={this.state.showModal}
            handleClose={this.closeModal}
            message={this.props.alertUsedMSG}
          />
        ) : null}
      </div>
    )
  }
}
const mapStateToProps = (state) => {
   return state.leadcustomerReducer
}


export default connect(
   mapStateToProps,
   actionCreator
)(SuccessOq);
